import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import "./MyCopyTradeRecords.css";
import BottomNavCopyTrading from "../Components/BottomNavCopyTrading";
export default function MyCopyTradeRecords() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const username = (
    localStorage.getItem("username") || ""
  ).trim();

  useEffect(() => {
    if (!username) {
      setError("Tafadhali ingia kwenye akaunti yako.");
      setLoading(false);
      return;
    }

    setLoading(true);

    const recordsQuery = query(
      collection(db, "copyTrades"),
      where("username", "==", username)
    );

    const unsubscribe = onSnapshot(
      recordsQuery,
      (snapshot) => {
        const userRecords = snapshot.docs.map((item) => ({
          id: item.id,
          ...item.data(),
        }));

        const getTime = (value) => {
          if (!value) return 0;

          if (typeof value.toDate === "function") {
            return value.toDate().getTime();
          }

          const time = new Date(value).getTime();
          return Number.isNaN(time) ? 0 : time;
        };

        userRecords.sort(
          (a, b) => getTime(b.createdAt) - getTime(a.createdAt)
        );

        setRecords(userRecords);
        setLoading(false);
        setError("");
      },
      (err) => {
        console.error("Copy trade records error:", err);
        setError("Imeshindikana kupakia rekodi zako.");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [username]);

  return (
    <section className="my-copy-records-page">
        
      <div className="mcr-header">
      <BottomNavCopyTrading/>

        <h2>My Copy Trading Records</h2>
        <span className="mcr-count">
          {records.length} Records
        </span>
      </div>

      {loading ? (
        <p className="mcr-message">Inapakia rekodi zako...</p>
      ) : error ? (
        <p className="mcr-message mcr-error">{error}</p>
      ) : records.length === 0 ? (
        <p className="mcr-message">
          Bado huna rekodi za Copy Trading.
        </p>
      ) : (
        <div className="mcr-table-wrapper">
          <table className="mcr-table">
            <thead>
              <tr>
                <th>Tarehe</th>
                <th>Trader</th>
                <th>Pair</th>
                <th>Investment</th>
                <th>Loss Alert</th>
                <th>Risk Level</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {records.map((record) => {
                const date = record.createdAt
                  ? typeof record.createdAt.toDate === "function"
                    ? record.createdAt.toDate()
                    : new Date(record.createdAt)
                  : null;

                const validDate =
                  date && !Number.isNaN(date.getTime());

                const status = String(
                  record.status || "pending"
                ).toLowerCase();

                const safeStatus = [
                  "pending",
                  "won",
                  "lost",
                ].includes(status)
                  ? status
                  : "other";

                return (
                  <tr key={record.id}>
                    <td>
                      {validDate ? date.toLocaleString() : "—"}
                    </td>

                    <td>{record.traderName || "Pro Trader"}</td>

                    <td>{record.pair || "—"}</td>

                    <td>
                      {Number(record.amount || 0).toLocaleString(
                        undefined,
                        { maximumFractionDigits: 2 }
                      )}{" "}
                      USDT
                    </td>

                    <td>
                      {record.riskLimit == null
                        ? "Not set"
                        : `${record.riskLimit}%`}
                    </td>

                    <td>{record.riskLevel || "—"}</td>

                    <td>
                      <span
                        className={`mcr-status mcr-status-${safeStatus}`}
                      >
                        {record.status || "pending"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}